import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { cn } from "@/lib/utils";

interface DateSelectFieldProps {
  value: Date | undefined;
  onChange: (date: Date | undefined) => void;
  placeholder?: string;
  label?: string;
  className?: string;
  error?: boolean;
  disabledDates?: (date: Date) => boolean;
}

export function DateSelectField({
  value,
  onChange,
  placeholder = "Pick a date",
  label,
  className,
  error,
  disabledDates,
}: DateSelectFieldProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={cn(
            "w-full pl-3 text-left font-normal",
            !value && "text-muted-foreground",
            error && "border-red-500",
            className,
          )}
        >
          {value ? format(value, "PPP") : <span>{placeholder}</span>}
          <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={value}
          onSelect={onChange}
          disabled={(date) => {
            const dayOfWeek = date.getDay();
            // Disable Friday (5), Saturday (6), and Sunday (0)
            if ([0, 5, 6].includes(dayOfWeek)) {
              return true;
            }
            // Apply any existing disabledDates logic
            return disabledDates ? disabledDates(date) : false;
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
